export default "__VITE_ASSET__Ca9A_Qe0__"